<template>
  <div class="justify-content-center row-filter">
    <loader v-if="pdfProcess"/>
    <loader class="table-loader" v-if="processingFilter"/>
    <div id="pdf-filers">
      <div class="row mt-2 mb-lg-3 mt-md-0" v-if="!processingFilter">
        <div class="col-12  col-lg-4">
          <h3 class="row-title">
            {{'report.choose_clinic_centre' | trans }} <sup
              class="text-danger">*</sup>
          </h3>
          <select-with-pager id="clinicalCenterId"
                             name="clinicalCenter"
                             class="load_more__select"
                             :label="'name'"
                             :selected=clinicalCenterId
                             :options="clinics"
                             :loading=loading
                             :lastId=lastId
                             :searchable="false"
                             :isLastPage=isLastPage
                             :optionTitle="'name'"
                             :class="{'is-invalid': errors.has('clinicalCenter'), 'is-clear': !clinicalCenterId}"
                             v-on:next-page="nextClinicalPage"
                             v-bind:isLast="isLast"
                             v-bind:getOptionTitle="getOptionTitle"
                             v-on:set-selected="onChangeClinicalCenter"
          >
          </select-with-pager>

        </div>

        <div class="col-12 mt-3 mt-lg-0 col-lg-8">

          <h3 class="row-title">
            {{'report.choose_period' | trans }} <sup class="text-danger">*</sup>
          </h3>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="datepicker datepicker__width">
            <span class="datepicker__label">
                 {{'report.range_from' | trans }}
            </span>

                <v-date-picker
                    v-model='rangeDateStart'
                    name='rangeDateStart'
                    :formats='formats'
                    title-position="left"
                    :input-props='{ readonly: true }'
                    :max-date='new Date()'
                    v-validate="'required|check-period'"
                    data-vv-validate-on="none"
                    :min-date="minDateStart">
                </v-date-picker>

                <mdc-icon icon="date_range"></mdc-icon>
              </div>
            </div>
            <div class="col-12  mt-2 mt-lg-0 col-lg-6">
              <div class="datepicker datepicker__width right">
                <span class="datepicker__label">
                     {{'report.range_end' | trans }}
                </span>

                <v-date-picker
                    v-model='rangeDateEnd'
                    :formats='formats'
                    title-position="left"
                    :input-props='{ readonly: true }'
                    :max-date='rangeDateFinish'
                    :min-date="rangeDateStart">
                </v-date-picker>

                <mdc-icon icon="date_range"></mdc-icon>
              </div>
            </div>
            <div class="col-12">
              <span class="description-row"
                    :class="{'invalid-feedback': errors.has('rangeDateStart')}">{{'report.description_max_period' | trans }}</span>
            </div>

          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3 mt-md-0" v-if="!processingFilter">
        <div id="div-client" class="col-12 col-lg-4">
          <h3 class="row-title">
            {{'report.choose_client' | trans }} <sup class="text-danger">*</sup>
          </h3>

          <select-with-pager id="mdc-client"
                             :disabled="disabledClient"
                             name="client_id"
                             class="load_more__select"
                             :label="'code'"
                             :selected=clientId
                             :options="clients"
                             :searchable="false"
                             :filterable="false"
                             :loading=loading
                             :lastId=lastClinicId
                             :isLastPage=isLastPageClient
                             :class="{'is-invalid': errors.has('client')}"
                             v-on:next-page="nextClientPage"
                             v-bind:isLast="isLastClient"
                             v-bind:getOptionTitle="getOptionClientTitle"
                             v-on:set-selected="onChangeClinicId"/>

          <span id="span-b" class="description-row">{{'report.description_choose_client' | trans }}</span>

        </div>
        <div class="col-12 mt-3 mt-lg-0 col-lg-4">
          <h3 class="row-title">
            {{'report.choose_skill' | trans }}
          </h3>
          <h4 class="row-sub-title">{{'report.start_skill' | trans }}</h4>
          <v-select v-model="skillField"
                    :options="skillFieldList"
                    :disabled="disabledSelect"
                    label="id"
                    name="skillField"
                    :filterable="false"
                    :onSearch="onSearchSkillField"
                    :on-change="onChangeSkillFieldId"
                    :placeholder="'report.all_skill' | trans"
                    class="aut-dropdown"
                    data-vv-validate-on="none">
            <template slot="no-options">
              <div @mousedown.stop="">
                {{ 'report.choose_skill' | trans }}
              </div>
            </template>
            <template slot="option" slot-scope="option">
              {{ option.name}}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option.name }}
            </template>
          </v-select>
          <span class="description-row">{{'report.description_choose_skill' | trans }}</span>

        </div>
        <div class="col-12 mt-3 mt-lg-0 col-lg-4">
          <h3 class="row-title">
            {{'report.choose_protocol' | trans }}
          </h3>
          <h4 class="row-sub-title">{{'report.start_protocol' | trans }}</h4>

          <v-select v-model="protocol"
                    :options="protocolList"
                    :disabled="disabledSelect"
                    label="protocolId"
                    name="protocol"
                    :filterable="false"
                    :placeholder="'report.all_protocol' | trans"
                    :onSearch="onSearchProtocol"
                    :on-change="onChangeProtocolId"
                    class="aut-dropdown"
                    data-vv-validate-on="none">
            <template slot="no-options">
              <div @mousedown.stop="">
                {{ 'report.choose_protocol' | trans }}
              </div>
            </template>
            <template slot="option" slot-scope="option">
              {{ option.title}}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option.title }}
            </template>
          </v-select>
          <span class="description-row">{{'report.description_choose_protocol' | trans }}</span>

        </div>
      </div>
    </div>

    <div class="row" v-if="!processingFilter">
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-12">
            <h3 class="row-title">{{ 'protocol.trendLineTitle' | trans }}</h3>
            <mdc-switch v-model="levelLineChecked">{{ 'protocol.levelLine' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="trendLineChecked">{{ 'protocol.trendLine' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="ScatterLineChecked">{{ 'protocol.scatterLine' |
              trans }}
            </mdc-switch>
          </div>
          <div class="col-12 mt-4">
            <h3 class="row-title">{{ 'protocol.showGraphsTitle' | trans }}</h3>
            <h4 class="row-sub-title mt-2 mb-2">{{'report.for_all_protocol' | trans }}</h4>
             <mdc-switch v-model="graphTotalPercentChecked">{{ 'protocol.total_percent_graph' | trans
              }} ({{'report.without_mand' | trans }})
            </mdc-switch>
            <mdc-switch v-model="graphPromptLevelsChecked">{{ 'protocol.graph_prompt_levels' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphCumulitiveChecked">{{ 'protocol.cumulitive_graph' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphImprovedSPOUChecked">{{ 'protocol.graph_improved_spou' | trans
              }} ({{'report.simple' | trans }})
            </mdc-switch>
          </div>
          <div class="col-12 mt-2">
            <h4 class="row-sub-title mt-2 mb-2">{{'report.for_chain' | trans }}</h4>
            <mdc-radio v-model="chartType" name="radios"
                       value="absolute" :label="'protocol.chain_step_chart' | trans"/>
            <mdc-radio v-model="chartType" name="radios"
                       value="relative" :label="'protocol.chain_mastered_chart' | trans"/>
          </div>

          <div class="col-12">
            <h4 class="row-sub-title mt-4 mb-2">{{'report.for_mand' | trans }}</h4>

            <mdc-switch v-model="graphMoYesPercentChecked">{{ 'protocol.graph_mo_yes_percent' | trans
              }}
            </mdc-switch>

            <mdc-switch v-model="graphMoYesChecked">{{ 'protocol.graph_mo_yes' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphProbeFullChecked">{{ 'protocol.graph_probe_full' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphMoGoalChecked">{{ 'protocol.graph_mo_goal' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphMandReactChecked">{{ 'protocol.graph_mand_react' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphGoalChecked">{{ 'protocol.graph_goal' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphCumulativeImproveChecked">{{ 'protocol.graph_cumulative_improve' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphImprovePromptChecked">{{ 'protocol.graph_improve_prompt' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="graphImproveChecked">{{ 'protocol.graph_improve' | trans
              }}
            </mdc-switch>

          </div>
        </div>
        
      </div>
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-12">
            <h3 class="row-title">{{ 'report.generate_version' | trans }}</h3>
            <mdc-switch v-model="pdfReport">{{ 'report.generate_pdf_version' | trans
              }}
            </mdc-switch>
            <mdc-switch v-model="csvReport">{{ 'report.generate_csv_version' | trans
              }}
            </mdc-switch>
          </div>

          <div class="col-12 mt-4" v-if="clientId">
            <mdc-switch v-model="showGraphUndesirableBehaviors ">
              {{'behavior.add_ub_to_report' | trans}}
            </mdc-switch>
          </div>
          <div class="col-12 mt-2" v-if="showGraphUndesirableBehaviors">
            <mdc-radio v-model="undesirableBehaviorGraphType" name="radiosUB"
                       value="1" :label="'behavior.all_ub_for_day' | trans"/>
          </div>
          <div class="col-12" v-if="showGraphUndesirableBehaviors">
            <mdc-radio v-model="undesirableBehaviorGraphType" name="radiosUB"
                       value="2" :label="'behavior.ub_for_day' | trans"/>
          </div>
          <div class="col-12" v-if="showGraphUndesirableBehaviors && undesirableBehaviorGraphType === '2'">
            <select-with-pager id="behaviorId"
                               name="behavior"
                               class="load_more__select"
                               :label="'text'"
                               :selected=behaviorId
                               :options="behaviorsList"
                               :loading=loading
                               :lastId=lastBehaviorsId
                               :searchable="false"
                               :isLastPage=isLastBehaviorsPage
                               :optionTitle="'text'"
                               :class="{'is-invalid': errors.has('behavior'), 'is-clear': !behaviorId}"
                               v-on:next-page="nextBehaviorsPage"
                               v-bind:isLast="isLastBehavior"
                               v-bind:getOptionTitle="getOptionBehaviorsTitle"
                               v-on:set-selected="onSetBehaviorsSelected"
            >
            </select-with-pager>
          </div>
        </div>
        
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3 text-right">
        <button type="button"
                class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="onSendRequest()"
                :disabled="!clientId">
          {{'report.draw_report' | trans }}
        </button>
      </div>
    </div>

    <loader class="table-loader" v-if="processing"/>

    <div v-if="showTable && !processing">
      <div id="pdf-client-table" class="col-12">
        <h3 class="table-title" v-if="client">{{'report.info_client' | trans }}:
          {{client}}</h3>
        <div class="table-responsive">
          <table class="table table-sm">
            <thead class="thead-light">
            <tr>
              <th>{{'protocol.protocol' | trans}}</th>
              <th>{{'report.introduced' | trans}}</th>
              <th>{{'report.mastered' | trans}}</th>
              <th>{{'report.total_time' | trans}}</th>
              <th>{{'report.sessions_total' | trans}}</th>
              <th>{{'protocol.protocol_status' | trans}}</th>
            </tr>
            </thead>
            <tbody class="gray-700">
            <tr v-for="item in statisticsList">
              <td>{{item.title}}</td>
              <td><span
                  v-if="item.createdAt">{{item.createdAt | toLocaleDate}}</span>
              </td>
              <td>
                <span
                    v-if="item.finishedAt">{{item.finishedAt | toLocaleDate}}</span>
                <span v-else>&mdash;</span>
              </td>
              <td>{{timeDuration(item.totalTimes)}}</td>
              <td>{{item.totalSessions}}</td>
              <td nowrap>
              <span class="status-badge"
                    :class="{'new-status' : isNew(item.statusId),
                    'individualize-status' : isIndividualize(item.statusId),
                 'active-status' : isActive(item.statusId),
                 'maintaining-status' : isMaintaining(item.statusId),
                 'completed-status' : isCompleted(item.statusId)}">
             </span>{{'protocol.statuses.' + item.statusName | trans}}
              </td>
            </tr>
            <tr class="total">
              <td>{{'report.total' | trans}}: {{totalStatisticsList.count}}</td>
              <td></td>
              <td></td>
              <td>{{timeDuration(totalStatisticsList.totalTimes)}}</td>
              <td>{{totalStatisticsList.totalSessions}}</td>
              <td></td>

            </tr>
            </tbody>
          </table>
        </div>

        <nav class="nav justify-content-center justify-content-md-start"
             v-if="paginate.lastPage > 1">
          <paginate :page-count="paginate.lastPage"
                    :page-range="paginate.pageRange"
                    :margin-pages="paginate.marginPages"
                    :force-page="paginate.forcePage"
                    :click-handler="onPaginationClick"
                    :container-class="'pagination pagination-sm'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'">
            <span slot="prevContent" class="page-link">&laquo;</span>
            <span slot="nextContent" class="page-link">&raquo;</span>
          </paginate>
        </nav>
      </div>
      <!--<div id="pdf-ub">
        <data-u-b
            :range-date-start=rangeDateStart
            :range-date-end=rangeDateEnd
            :clientTimezone="user.timezone"
            :client-id=clientId.id
            :change-data="changeData"/>
      </div>
      <div id="pdf-appeals">
        <data-appeals
            :range-date-start=rangeDateStart
            :range-date-end=rangeDateEnd
            :clientTimezone="user.timezone"
            :client-id=clientId.id
            :change-data="changeData"/>
      </div>-->

    </div>

    <div class="col-12 mt-3 text-right" v-if="showTable && !processing">
      <button type="button" :disabled="isSaveDisable"
              class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
              @click.prevent="saveRequest()">
        {{'report.save_report' | trans }}
      </button>
    </div>

  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import axios from 'axios';
  import forIn from 'lodash/forIn';
  import DataUB from './DataUB';
  import DataAppeals from './DataAppeals';
  import DataEfficiency from './DataEfficiency';
  import Slick from 'vue-slick';
  import Manager from '../api/Manager';
  import Constants from '../../undesirableBehavior/Constants';
  import moment from 'moment';
  import {pagination} from '../../../common/mixins/pagination';
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import parseInt from 'lodash/parseInt';
  import Loader from '../../loader/components/Loader';
  import {PROTOCOL_STATUSES} from '../../protocols/constants.js';
  import PdfReportClient from '../../reports/components/PdfReportClient';
  import selectWithPager from '../../../common/selectWithPager/components/SelectWithPager';
  import forEach from 'lodash/forEach';
  import {LineChart, LineChartDataset} from '../../../common/chart';
  import {Validator} from 'vee-validate';
  import toInteger from 'lodash/toInteger';
  import debounce from 'lodash/debounce';
  import filter from 'lodash/filter';
  import apiUndesirableBehavior  from '../../undesirableBehavior/api/undesirableBehavior';

  export default {
    name: 'ClientsList',
    props: {
      'isEdit': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'id': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'skillFieldId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'skillFieldName': {
        type: [String],
        default() {
          return null;
        },
      },
      'protocolTitle': {
        type: [String],
        default() {
          return null;
        },
      },
      'clinicId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'startDate': {
        type: [Object],
      },
      'endDate': {
        type: [Object],
      },
      'csvShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'pdfShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'levelLineShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'trendLineShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'scatterLineShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'graphMoYesPercentShow': {
        type: Boolean,
        default() {
          return true;
        },
      },
      'graphTotalPercentShow': {
          type: Boolean,
          default() {
              return true;
          },
      },
      'graphPromptLevelsShow': {
          type: Boolean,
          default() {
              return true;
          },
      },
      'graphImprovedSPOUShow': {
          type: Boolean,
          default() {
              return true;
          },
      },
      'graphMoYesShow': {
        type: Boolean,
        default() {
         return false;
        },
      },
      'graphProbeFullShow': {
        type: Boolean,
        default() {
         return false;
        },
       },
       'graphMoGoalShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphMandReactShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphGoalShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphCumulativeImproveShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphImprovePromptShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphImproveShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
       'graphCumulitiveShow': {
         type: Boolean,
         default() {
          return false;
         },
       },
      'graphAboluteShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'graphRelativeShow': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'graphUndesirableBehaviors': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'behaviorGraphType': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'behaviorUBId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
        },
        data() {
          return {
            apiUrl: '/users/clients/',
            clients: [],
            clientId: null,
            client: '',
            apiSaveUrl: '/statistics/reports/clients/',
            perPage: 10,
            page: 1,
            pageClient: 1,
            pdfProcess: false,
            rangeDateStart: new Date(),
            rangeDateEnd: new Date(),
            minDateStart: this.getMinDateStart(new Date()),
            rangeDateFinish: this.getMaxDateFinish(new Date()),
            formats: {
              title: 'MMMM YYYY',
              weekdays: 'WW',
              navMonths: 'MMM',
              input: ['DD MMM YYYY'],
              dayPopover: 'L',
              data: ['DD MMM YYYY'],
            },
            showTable: false,
            changeData: null,
            clinics: [
              {id: null, name: lang.get('report.all_centre')},
            ],
            disabledClient: false,
            disabledSelect: true,
            skillField: null,
            allSkillField: null,
            skillFieldList: [],
            allSkillFieldList: [],
            protocolList: [],
            protocol: null,
            statisticsList: [],
            totalStatisticsList: [],
            paginateData: null,
            efficiencyList: null,
            currentSkillFieldIndex: null,
            processing: false,
            processingFilter: false,
            fromAchive: false,
            isSaveDisable: false,
            loading: false,
            lastId: null,
            lastClinicId: null,
            isLastPage: false,
            isLastPageClient: false,
            scaleLabel: {
              display: true,
              labelString: lang.get('protocol.average_percent'),
            },
            slickOptions: {
              adaptiveHeight: true,
            },
            levelLineChecked: false,
            trendLineChecked: false,
            ScatterLineChecked: false,
            graphMoYesPercentChecked: true,
            graphTotalPercentChecked: true,
            graphPromptLevelsChecked: true,
            graphImprovedSPOUChecked: true,
            graphMoYesChecked: false,
            graphProbeFullChecked: false,
            graphMoGoalChecked: false,
            graphMandReactChecked: false,
            graphGoalChecked: false,
            graphCumulativeImproveChecked: false,
            graphImprovePromptChecked: false,
            graphImproveChecked: false,
            graphCumulitiveChecked: false,
            pdfReport: false,
            csvReport: false,
            chartType: 'absolute',
            showGraphUndesirableBehaviors: false,
            undesirableBehaviorGraphType: '1',
            undesirableBehaviorBehaviorId: null,
            behaviorId: {id: null, text: lang.get('behavior.all_ub')},
            lastBehaviorsId: null,
            behaviorsList: [{id: null, text: lang.get('behavior.all_ub')}],
            isLastBehaviorsPage: false,
          };
        },
        mixins: [pagination],
        components: {
          DataAppeals,
          DataUB,
          Slick,
          DataEfficiency,
          Loader,
          PdfReportClient,
          selectWithPager,
          LineChart,
        },
        async created() {

          Validator.extend('check-period', {
            getMessage: attribute => lang.get('rotation.unique_stimulus',
                {attribute}),
            validate: () => {
              let date = new Date(this.rangeDateStart.getFullYear(),
                  (this.rangeDateStart.getMonth() + 4),
                  this.rangeDateStart.getDate(),
                  this.rangeDateEnd.getHours(),
                  this.rangeDateEnd.getMinutes(),
                  this.rangeDateEnd.getSeconds(),
                  this.rangeDateEnd.getMilliseconds(),
              );
              return this.rangeDateEnd.getTime() <= date.getTime();
            },
          });

          this.processingFilter = true;

          let that = this;
          let response = await Manager.getClinicalCenters(this.perPage,
              this.page);
          response.data.data.items.forEach(function(item) {
            that.clinics.push(item);
          });

          this.lastId = this.clinics[this.clinics.length - 1].id;
          if (response.data.data.hasMorePages) {
            this.page++;
          } else {
            this.isLastPage = true;
          }

          if (this.isEdit) {
            this.rangeDateStart = moment(this.startDate.date)._d;
            this.rangeDateEnd = moment(this.endDate.date)._d;
            this.pdfReport = this.pdfShow;
            this.csvReport = this.csvShow;
            this.levelLineChecked = this.levelLineShow;
            this.trendLineChecked = this.trendLineShow;
            this.ScatterLineChecked = this.scatterLineShow;
            this.graphMoYesPercentChecked = this.graphMoYesPercentShow;
            this.graphTotalPercentChecked = this.graphTotalPercentShow;
            this.graphPromptLevelsChecked = this.graphPromptLevelsShow;
            this.graphImprovedSPOUChecked = this.graphImprovedSPOUShow;
            this.graphMoYesChecked = this.graphMoYesShow;
            this.graphProbeFullChecked = this.graphProbeFullShow;
            this.graphMoGoalChecked = this.graphMoGoalShow;
            this.graphMandReactChecked = this.graphMandReactShow;
            this.graphGoalChecked = this.graphGoalShow;
            this.graphCumulativeImproveChecked = this.graphCumulativeImproveShow;
            this.graphImprovePromptChecked = this.graphImprovePromptShow;
            this.graphImproveChecked = this.graphImproveShow;
            this.graphCumulitiveChecked = this.graphCumulitiveShow;

            this.chartType = this.graphAboluteShow ? 'absolute' : 'relative';
            this.fromAchive = true;
          } else {
            let dt = new Date();
            let date = new Date(dt.getFullYear(), (dt.getMonth() - 1),
                dt.getDate());
            this.rangeDateStart = date;
          }

          if (response) {
            if (this.isEdit) {
              if (this.clinicId) {
                this.getCurrentClinicalCenter(this.clinicId);
              } else {
                this.clinicalCenterId = this.clinics[0];
                this.processingFilter = false;
              }
            } else {
              this.processingFilter = false;
              this.clinicalCenterId = this.clinics[0];
            }

            //this.onChangeClinicalCenter(this.clinicalCenterId)
          }
        },
        methods: {

          timeDuration(time) {
            let min = time*60;
            let minDuration = toInteger(min);
            let secDuration = toInteger(min*60 - minDuration*60);
            let timeDuration = time ? minDuration + lang.get('behavior.min') + ' ' + secDuration  + lang.get('behavior.sec') : 0 + lang.get('behavior.min');

            return timeDuration;
          },

          isNew: function(id) {
            return id === PROTOCOL_STATUSES.NEW;
          },

          isActive: function(id) {
            return id === PROTOCOL_STATUSES.ACTIVE;
          },

          isMaintaining: function(id) {
            return id === PROTOCOL_STATUSES.MAINTAINING;
          },

          isCompleted: function(id) {
            return id === PROTOCOL_STATUSES.COMPLETED;
          },

          isIndividualize: function(id) {
            return id === PROTOCOL_STATUSES.INDIVIDUALIZATION;
          },

          getOptionTitle: function({option}) {
            return option.name;
          },
          getOptionClientTitle: function({option}) {
            return option.code;
          },
          isLast: function({option}) {
            return option.id == this.lastId;
          },
          isLastBehavior: function({option}) {
            return option.id == this.lastBehaviorsId;
          },

          onSetBehaviorsSelected(selected){
            this.behaviorId = selected
          },

          isLastClient: function({option}) {
            return option.id == this.lastClinicId;
          },

          async onChangeClinicalCenter(val) {
            this.disabledClient = true;
            this.lastClinicId = null;
            this.isLastPageClient = false;
            this.pageClient = 1;

            let response = await Manager.getClients(val.id, this.perPage,
                this.pageClient);
            this.clients = response.data.data.items;

            if (this.clients.length) {
              this.disabledClient = false;
              this.lastClinicId = this.clients[this.clients.length - 1].id;
              if (response.data.data.lastPage != this.pageClient) {
                this.pageClient++;
              } else {
                this.isLastPageClient = true;
              }
              this.clinicalCenterId = val;
              if (this.id && this.clients && this.fromAchive) {

                this.getCurrentClient(this.id);
              } else {
                this.showTable = false;
                this.clientId = null;
              }
              if (response) {
                this.loading = false;
              }

            } else {
              this.disabledClient = true;
            }
          },

          onChangeClinicId: function(selected) {
            this.clientId = selected;
          },

          nextClinicalPage: async function() {
            if (!this.isLastPage) {
              this.loading = true;
              let response = await Manager.getClinicalCenters(this.perPage,
                  this.page);
              response.data.data.items.forEach((item) => {
                this.clinics.push(item);
              });

              if (response) {
                this.loading = false;
              }
              this.lastId = this.clinics[this.clinics.length - 1].id;
              if (response.data.data.lastPage != this.page) {
                this.page++;
              } else {
                this.isLastPage = true;
              }
            }
          },

          nextClientPage: async function() {
            if (!this.isLastPageClient) {
              this.loading = true;
              let response = await Manager.getClients(this.clinicalCenterId.id,
                  this.perPage, this.pageClient);
              response.data.data.items.forEach((item) => {
                this.clients.push(item);
              });
              this.lastClinicId = this.clients[this.clients.length - 1].id;
              if (this.pageClient == response.data.data.lastPage) {
                this.isLastPageClient = true;
              } else {
                this.pageClient++;
              }

              if (response) {
                this.loading = false;
              }
            }
          },

          getCurrentSkillFieldIndex: function(id) {
            this.currentSkillFieldIndex = findIndex(this.efficiencyList,
                (skillField) => {
                  return skillField.skillFieldId === id;
                });
          },

          getCurrentSlideIndex: function(id) {
            this.currentSlideIndex = findIndex(this.allSkillFieldList,
                (skillField) => {
                  return skillField.id === id;
                });
          },

          getCurrentClient: async function(id) {
            let response = await Manager.getClient(id);
            this.clientId = {
              id: response.data.data.id,
              code: response.data.data.code,
            };

            if(this.isEdit && this.clientId){
              this.showGraphUndesirableBehaviors = this.graphUndesirableBehaviors;
              this.undesirableBehaviorGraphType = this.behaviorGraphType ? this.behaviorGraphType.toString() : null;
            }

          },

          getCurrentClinicalCenter: async function(id) {
            let response = await Manager.getClinicalCenter(id);
            if (response) {
              this.clinicalCenterId = response.data.data;
              this.processingFilter = false;
            }
          },

          getComments: function() {
            let comments = [];
            forIn(this.efficiencyList, (item) => {
              if (item.comment) {
                comments.push({
                  'skillFieldId': item.skillFieldId,
                  'protocolId': item.protocolId,
                  'text': item.comment,
                });
              }
            });
            return comments;
          },

          async onPaginationClick(pageNum) {
            this.onPaginationBtnClick(pageNum);
            let response = await Manager.getStatistics(this.clientId.id,
                500, pageNum,
                this.rangeDateStartTimestamp, this.rangeDateEndTimestamp,
                this.skillField ? this.skillField.id : null,
                this.protocol ? this.protocol.protocolId : null);
            this.statisticsList = response.data.data.items;
            this.totalStatisticsList = response.data.data.itemsTotal;
          },
          clientTimezone() {
            return this.user.timezone;
          },
          findClientById: function(client) {
            let that = this;
            forIn(this.clients, function(item) {
              if (item.id == id) {
                that.client = item.code;
              }
            });
          },
          getMinDateStart: function(date) {
            let minDateStart = new Date((date.getFullYear() - 1),
                date.getMonth(),
                date.getDate());
            return minDateStart;
          },
          getMaxDateFinish: function(date) {
            let minDateStart = new Date((date.getFullYear()),
                date.getMonth(),
                date.getDate() + 2);
            return minDateStart;
          },
          async onSendRequest(fromArchive = false) {
            let result = await this.$validator.validateAll();
            if (!result) {
              return;
            }
            this.isSaveDisable = fromArchive;
            this.showTable = false;
            this.processing = true;
            this.client = this.clientId ? this.clientId.code : '';
            //this.findClientById(this.clientId)
            this.changeData = this.clientId.id + this.rangeDateStart +
                this.rangeDateEnd;

            let response = await Manager.getStatistics(this.clientId.id,
                500, 1,
                this.rangeDateStartTimestamp, this.rangeDateEndTimestamp,
                this.skillField ? this.skillField.id : null,
                this.protocol ? this.protocol.protocolId : null,
                this.levelLineChecked,
                this.trendLineChecked,
                this.ScatterLineChecked,
                this.graphMoYesPercentChecked,
                this.graphTotalPercentChecked,
                this.graphPromptLevelsChecked,
                this.graphImprovedSPOUChecked,
                this.graphMoYesChecked,
                this.graphProbeFullChecked,
                this.graphMoGoalChecked,
                this.graphMandReactChecked,
                this.graphGoalChecked,
                this.graphCumulativeImproveChecked,
                this.graphImprovePromptChecked,
                this.graphImproveChecked,
                this.graphCumulitiveChecked,
                this.chartType === 'absolute',
                this.chartType === 'relative',
                this.showGraphUndesirableBehaviors,
                this.showGraphUndesirableBehaviors ? this.undesirableBehaviorGraphType : null,
                this.showGraphUndesirableBehaviors && this.undesirableBehaviorGraphType === '2' && this.behaviorId ? this.behaviorId.id : null

            );
            this.statisticsList = response.data.data.items;
            this.totalStatisticsList = response.data.data.itemsTotal;
            this.paginateData = response.data.data;

            /*let responseEfficiency = await Manager.getEfficiency(this.clientId.id,
                500, 1,
                this.rangeDateStartTimestamp, this.rangeDateEndTimestamp,
                this.skillField ? this.skillField.id : null,
                this.protocol ? this.protocol.protocolId : null);
            this.efficiencyList = responseEfficiency.data.data.items;

            if (!this.skillField) {
              let responseSkillField = await Manager.getSkillField();
              this.allSkillFieldList = responseSkillField.data.data.items;
              this.allSkillField = this.allSkillFieldList[0];
            }
            */

            if (response) {
              this.showTable = true;
              this.processing = false;
              this.fromAchive = false;
            }

          },
          onSearchSkillField:  debounce(
            async function (search) {
              let response = await Manager.getSkillField(this.clientId.id, 500, 1,
                  this.rangeDateStartTimestamp, this.rangeDateEndTimestamp,
                  search);
              this.skillFieldList = response.data.data.items;
            }, 500
          ),
          async onChangeSkillFieldId(val) {
            this.skillField = val;

            if (val && !this.fromAchive) {
              this.protocol = null;
              this.protocolList = [];
            }

            if (!val) {
              this.skillFieldList = [];
            }
          },

          async onChangeProtocolId(val) {
            this.protocol = val;

            if (!val) {
              this.skillFieldList = [];
            }
          },
          onSearchProtocol:  debounce(
            async function (search) {
              let response = await Manager.getProtocols(
                  this.clientId.id,
                  500, 1,
                  this.rangeDateStartTimestamp,
                  this.rangeDateEndTimestamp,
                  this.skillField ? this.skillField.id : null,
                  search);
              this.protocolList = response.data.data.items;
            }, 500
          ),
          handleAfterChange(event, slick, currentSlide) {
            let slide = parseInt(slick.$slides.get(currentSlide).
                getElementsByClassName('item-slide')[0].dataset.slide);
            this.getCurrentSlideIndex(slide);
            this.allSkillField = this.allSkillFieldList[this.currentSlideIndex];
          },

          onChangeSkillField(val) {
            this.getCurrentSkillFieldIndex(val.id);
            if (this.currentSkillFieldIndex) {
              this.$refs.slick.goTo(this.currentSkillFieldIndex);
            }
          },

          nextBehaviorsPage: async function() {
            if (!this.isLastBehaviorsPage) {
              this.loading = true;
              let response = await apiUndesirableBehavior.getBehaviors(
                this.clientId.id,
                this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : 'all',
                'all',
                this.perPage,
                this.pageBehaviors,
                this.rangeDateStartTimestamp,
                this.rangeDateEndTimestamp);

              response.data.data.items.forEach((item) => {
                this.behaviorsList.push(item);
              });

              if (response) {
                this.loading = false;
              }
              this.lastBehaviorsId = this.behaviorsList[this.behaviorsList.length - 1].id;
              if (response.data.data.hasMorePages) {
                this.pageBehaviors++;
              } else {
                this.isLastBehaviorsPage = true;
              }
            }

            if(this.isEdit && this.behaviorUBId){
              let currentUB = filter(this.behaviorsList, item => {
                return item.id === this.behaviorUBId;
              });

              this.behaviorId = currentUB[0];

            }
          },

          getOptionBehaviorsTitle: function({option}) {
            return option.text;
          },

          async saveRequest() {

            let comments = this.getComments();
            this.pdfProcess = true;

            let isSaved = await axios.post(this.apiSaveUrl, {
              'title': lang.get('user.client') + ' ' + this.client,
              'clientId': this.clientId.id,
              'startDate': this.rangeDateStartTimestamp,
              'endDate': this.rangeDateEndTimestamp,
              'clinicalCenterId': this.clinicalCenterId.id,
              'skillFieldId': this.skillField ? this.skillField.id : null,
              'protocolId': this.protocol ? this.protocol.protocolId : null,
              'comments': comments,
              'pdfReport': this.pdfReport,
              'csvReport': this.csvReport,
              'undesirableBehaviorGraphType': this.showGraphUndesirableBehaviors ? this.undesirableBehaviorGraphType : null,
              'undesirableBehaviorBehaviorId': this.showGraphUndesirableBehaviors && this.undesirableBehaviorGraphType === '2' && this.behaviorId &&  this.behaviorId.id !== 'all'  ? this.behaviorId.id : null,
              'chartOptions': {
                'showLevelLine': this.levelLineChecked,
                'showTrendLine': this.trendLineChecked,
                'showScatterLine': this.ScatterLineChecked,
                'showGraphMoYesPercent': this.graphMoYesPercentChecked,
                'showGraphTotalPercent':  this.graphTotalPercentChecked,
                'showGraphPromptLevels':  this.graphPromptLevelsChecked,
                'showGraphImprovedSPOU': this.graphImprovedSPOUChecked,
                'showGraphMoYes': this.graphMoYesChecked,
                'showGraphProbeFull': this.graphProbeFullChecked,
                'showGraphMoGoal': this.graphMoGoalChecked,
                'showGraphMandReact': this.graphMandReactChecked,
                'showGraphGoal':this.graphGoalChecked,
                'showGraphCumulativeImprove': this.graphCumulativeImproveChecked,
                'showGraphImprovePrompt': this.graphImprovePromptChecked,
                'showGraphImprove': this.graphImproveChecked,
                'showGraphCumulitive': this.graphCumulitiveChecked,
                'showAbsolute': this.chartType === 'absolute',
                'showRelative': this.chartType === 'relative',
                'showGraphUndesirableBehaviors': this.showGraphUndesirableBehaviors
              },
            });

            if (isSaved) {
              this.pdfProcess = false;
              this.$router.push({name: 'archive-reports'});
            }
          },
          async generatePdf() {
            this.pdfProcess = true;
            let response = await axios.post('/users/clients/export/' +
                this.clientId.id, {
              'startDate': this.rangeDateStartTimestamp,
              'endDate': this.rangeDateEndTimestamp,
              'clinicalCenterId': this.clinicalCenterId.id,
              'skillFieldId': this.skillField ? this.skillField.id : null,
              'protocolId': this.protocol ? this.protocol.protocolId : null,
              'comments': this.getComments(),
            });
            let hash = response.data.data.hash;
            let url = process.env.APP_URL +
                `/users/reports/download?hash=${hash}`;
            let link = document.createElement('a');
            link.href = url;
            let node = document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              node.remove();
              this.pdfProcess = false;
            });
          },

          trans: function(key) {
            return lang.get(key);
          },

          toLocaleDate: function(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
          },

          fetchDatasetForChart(item) {
            let data = [];
            const isMasteringChart = !!item.masteringEfficiency;
            item.scaleLabel = {
              labelString: '',
              display: true,
            };
            item.scaleLabel.labelString = isMasteringChart ?
                lang.get('protocol.mastering_percent') :
                lang.get('protocol.average_percent');
            let daySessions = isMasteringChart ?
                item.masteringEfficiency.daySessions :
                item.daySessions;
            forEach(daySessions, (day) => {
              data.push(
                  {
                    x: this.toLocaleDate(day.day),
                    y: day.percent,
                  },
              );
            });

            return new LineChartDataset({
              data,
            });
          },
        },
        computed: {
          ...mapGetters('auth', [
            'isBCBA',
            'user',
          ]),
          ...mapState([
            'route',
          ]),
          ...mapGetters('mobile', [
            'isMobile',
          ]),
          rangeDateStartTimestamp() {
            return moment(this.rangeDateStart).unix() +
                (Math.abs(this.rangeDateStart.getTimezoneOffset()) *
                    Constants.SECONDS_PER_MINUTE);
          },
          rangeDateEndTimestamp() {
            return moment(this.rangeDateEnd).unix() +
                (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                    Constants.SECONDS_PER_MINUTE);
          },
        },
        watch: {
          paginateData() {
            this.setPaginate(this.paginateData);
          },
          rangeDateStart(newValue, oldValue) {
            this.showTable = false;
            if (!newValue) {
              this.rangeDateStart = oldValue;
              return;
            }
            if (!this.fromAchive) {
              this.showGraphUndesirableBehaviors = false;
              this.skillField = null;
              this.skillFieldList = [];
              this.protocol = null;
              this.protocolList = [];
            }
          },
          rangeDateEnd(newValue, oldValue) {
            if (!this.fromAchive) {
              this.showGraphUndesirableBehaviors = false;
            }
            if (!newValue) {
              this.rangeDateEnd = oldValue;
              this.minDateStart = this.getMinDateStart(oldValue);
            } else {
              this.minDateStart = this.getMinDateStart(newValue);
              this.skillField = null;
              this.skillFieldList = [];
              this.protocol = null;
              this.protocolList = [];
            }
          },
          clientId(id) {
            if (id) {
              this.disabledSelect = false;
              this.showTable = false;

              if (this.fromAchive) {
                if (this.skillFieldId || this.skillFieldName) {
                  this.skillFieldList = [
                    {id: this.skillFieldId, name: this.skillFieldName},
                  ];
                  console.log('this.skillFieldList', this.skillFieldList)
                }

                this.skillField = this.skillFieldList[0];

                if (this.protocolId || this.protocolTitle) {
                  this.protocolList = [
                    {protocolId: this.protocolId, title: this.protocolTitle},
                  ];
                }
                this.protocol = this.protocolList[0];

                this.onSendRequest(true);
                //this.fromAchive = false;
              } else {
                this.showGraphUndesirableBehaviors = false;
                this.skillField = null;
                this.skillFieldList = [];
                this.protocol = null;
                this.protocolList = [];
              }

            }
          },
          skillField(newValue){
            if (!this.fromAchive) {
              this.showGraphUndesirableBehaviors = false;
            }
          },
          protocol(newValue){
            if (!this.fromAchive) {
              this.showGraphUndesirableBehaviors = false;
            }
          },
          showGraphUndesirableBehaviors(newValue){
            if(newValue){
              this.pageBehaviors =1;
              this.behaviorId = {id: null, text: lang.get('behavior.all_ub')};
              this.lastBehaviorsId = null;
              this.isLastBehaviorsPage = false;
              this.behaviorsList = [{id: null, text: lang.get('behavior.all_ub')}];
              this.nextBehaviorsPage();
            }
          }
        },
      };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/reports/components/ClientsList.vue